export default function s3ImageURL(key: string, appname?: string): string {
  if (process.env.NODE_ENV == 'development') {
    return `/s3/${key}`
  }
  return `${process.env.NEXT_PUBLIC_MEDIA_BUCKET}/${appname ?? process.env.NEXT_PUBLIC_APP}/${key}`
}
